import React from "react";
import { Theme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import classnames from "classnames";

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
    register?: any,

    isTitle?: boolean,
    isText?: boolean,
    isError?: boolean,
    disabled?: boolean,
}

export default function LabelForm({ isTitle = true, isText = false, isError = false, disabled = false, ...props }: Props) {
    const { register, ref, children, className, ...rest } = props;

    const classes = useStyles({disabled});

    return (
        <span
            {...rest}
            ref={register || ref}
            className={
                classnames(
                    classes.label,
                    isTitle ? classes.title : "",
                    isText ? classes.text : "",
                    isError ? classes.error : "",
                    className
                )
            }
        >
            {children}
        </span>
    );
}


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        label: {
            fontFamily: "Manrope",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "24px",
            whiteSpace: "nowrap",
            color: (props: { disabled?: boolean }) => (props?.disabled) ? "#667085" : "#465869"
        },
        title: {
            fontWeight: "bold",
        },
        text: {
            fontWeight: "normal"
        },
        error: {
            color: "red",
            fontWeight: 500,
            fontSize: 11,
        },
    }),
);